import classNames from "classnames";
import { memo } from "react";
import { OptionTemplate } from "shared/api/middleware-api-client";
import Icon, { IconTypes } from "shared/ui/icon";
import Text from "shared/ui/typography/Text";
import { concatClassnames } from "shared/utils/concatClassnames";

interface ProductProps {
  color: OptionTemplate;
  isActive: boolean;
  selectColor: (color: OptionTemplate) => void;
}

export const elementSize = "gg-relative gg-w-16 sm:gg-w-24 gg-aspect-square";

export const DoorColorChoice = memo(
  ({ color, isActive, selectColor }: ProductProps) => {
    return (
      <button
        aria-pressed={isActive}
        className="gg-flex gg-flex-col gg-items-start gg-text-left"
        onClick={() => selectColor(color)}
      >
        <div
          className={classNames(
            "gg-flex gg-items-center gg-justify-center",
            "gg-relative",
            "gg-mb-1 gg-rounded gg-border gg-transition gg-duration-300 gg-ease-in-out hover:gg-scale-[1.015] hover:gg-border-[#9493A3]",
            "gg-bg-contain gg-shadow-sm",
            {
              "gg-border-[#9493A3]": isActive,
              "gg-border-[#EAE9ED]": !isActive,
            },
            elementSize,
          )}
          style={{
            backgroundColor: color.material?.color,
          }}
        >
          {isActive && (
            <span
              className={concatClassnames(
                "gg-flex gg-h-6 gg-w-6 gg-bg-green-500",
                "gg-items-center gg-justify-center gg-rounded-full",
                "gg-absolute -gg-right-3 -gg-top-3 gg-h-2",
              )}
            >
              <Icon name={IconTypes.WHITE_CHECK} alt="" className="gg-h-2" />
            </span>
          )}
        </div>

        <Text className="gg-w-12 gg-text-xs gg-font-bold sm:gg-w-20">
          {color.name}
        </Text>
      </button>
    );
  },
);
